export const favoritAction = (favoritCards) => {
    return {
        type: "FAVORIT_CARDS",
        payload: favoritCards,
    };
};
